<template>
  <div class="evento-container">
    <div class="rasgado rasgado-superior"></div>
<!-- FLORES DECORATIVAS LATERALES -->
<div class="flores-laterales">
  <img ref="flor1" src="@/assets/flor1.png" class="flor flor1" />
  <img ref="flor2" src="@/assets/flor1.png" class="flor flor2" />

</div>

    <!-- DECORACIÓN DE BESOS -->
 

    <!-- BOLAS DISCOTECA GIRANDO -->
    <div class="bolas-container">
      <img ref="bola2" src="@/assets/disco.png" class="bola bola-right" />

    </div>

    <!-- ENCABEZADO -->
   
      <!-- LÍNEA ANIMADA CONECTOR -->

      <!-- RECEPCIÓN -->
      <div class="evento-card">
            <br>    <br>    <br>

       <!--   <div class="icono-evento">
          <img src="@/assets/celebracionpng.png" alt="Ícono recepción" />
        </div>-->
        <img src="@/assets/mapa.png" alt="Ícono ceremonia" class="icono-mapa" />

        <p class="evento-tipo">Recepción</p>
        <div ref="imgRecepcion" class="evento-imagen-wrapper">
          <img src="@/assets/marco.png" class="marco-decorativo" />
        </div>
        <div ref="infoRecepcion" class="evento-info">
          <p class="evento-lugar">El Quijote Salón de Actividades

</p>
          <p class="evento-direccion">
       PR-738 km 1.7<br />  Cayey, Puerto Rico.
          </p>
          <p class="hora">4:30 PM</p>
                <img src="@/assets/mapa.png" alt="Ícono ceremonia" class="icono-mapa" />
<br>

          <a href="https://maps.app.goo.gl/VVP7SPcGXuL2trpa9" class="btn-mapa" target="_blank">
            ¿Cómo llegar?
          </a>
        </div>
        <div class="rasgado rasgado-inferior"></div>

      </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',
  setup() {
    const infoRecepcion = ref(null)
   
    const imgRecepcion = ref(null)
    const bola2 = ref(null)
const flor1 = ref(null)
const flor2 = ref(null)

    const animarElemento = (element) => {
      gsap.fromTo(
        element,
        { opacity: 0, y: 60 },
        { opacity: 1, y: 0, duration: 1.5, ease: 'power2.out' }
      )
    }
const animarDesdeIzq = (element) => {
  gsap.fromTo(
    element,
    { opacity: 0, x: -100 },
    { opacity: 1, x: 0, duration: 1.2, ease: 'power2.out' }
  )
}

const animarDesdeDer = (element) => {
  gsap.fromTo(
    element,
    { opacity: 0, x: 100 },
    { opacity: 1, x: 0, duration: 1.2, ease: 'power2.out' }
  )
}
   

    const rotarBola = (element) => {
      gsap.fromTo(
        element,
        { rotate: -90, scale: 0 },
        { rotate: 360, scale: 1, duration: 2.5, ease: 'elastic.out(1, 0.4)' }
      )
    }

    onMounted(() => {
      const observar = (el, accion) => {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              accion()
              obs.unobserve(entry.target)
            }
          })
        }, { threshold: 0.4 })
        observer.observe(el.value)
      }

     
      observar(imgRecepcion, () => animarElemento(imgRecepcion.value))
      observar(infoRecepcion, () => animarElemento(infoRecepcion.value))
      observar(flor1, () => animarDesdeIzq(flor1.value))
      observar(flor2, () => animarDesdeDer(flor2.value))
      observar(bola2, () => rotarBola(bola2.value))
    })

    return {
      infoRecepcion,
       flor1,
  flor2,
 

      imgRecepcion,
      bola2
    }
  }
}
</script>
<style scoped>
.evento-container {
  /* ...lo que ya tienes */
background-image: 
  linear-gradient(to bottom, rgba(251, 248, 248, 0.692), rgba(255, 255, 255, 0.477)),
  url('../assets/gold.jpg');
  color: #fff;
  margin-top: -30px;
  overflow: visible;

  margin-bottom: -20px;
  background-size: cover;
  background-position: center;
  padding-bottom: 40px;
height: 90hv;
  /* AÑADE ESTO: */
  position: relative;
}


.encabezado-ubicacion {
  text-align: center;
  margin-bottom: 16px;
}

.linea-decorativa {
  width: 40px;
  height: 1px;
  background-color: #413d3d;
  margin: 8px auto;
  transform: scaleX(0);
}

.evento-card {
  max-width: 400px;
  margin: 0 auto 40px;
  text-align: center;
  padding: 0px 0;
  margin-top:30px;
  border-radius: 12px;
  overflow: visible;
}

.icono-evento {
  margin-top: 20px;
}

.icono-evento img {
  width: 100px;
  height: auto;
  display: inline-block;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2));
}

.evento-imagen-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.25));
}

.imagen-fondo {
  width: 80%;
  max-height: 200px;
  object-fit: cover;
  display: block;
  border-radius: 2px;
  box-shadow: 0 10px 25px rgba(237, 233, 233, 0.016);
  position: relative;
  z-index: 1;
  margin: 0 auto;
}

.evento-imagen-wrapper::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 80%;
  height: 30%;
  background: linear-gradient(to top, rgba(255, 255, 255, 0), transparent);
  pointer-events: none;
  z-index: 0;
  border-radius: 2px;
}

.marco-decorativo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  mix-blend-mode: lighten;
  opacity: 0.8;
  filter: brightness(0.4); /* 🔥 Oscurece ligeramente el marco */
}

.evento-info {
  padding: 19px;
  color: #020202d9;
  opacity: 0;
}

.hora {
  font-family: 'fa';
  font-size: 19px;
  margin-bottom: 4px;
  color: #000000;
}

.evento-tipo {
  font-family: 'britishgruesa', sans-serif;
  font-size: 54px;
  margin-bottom: 12px;
  font-weight: 700;
  color: #434040;
}

.evento-lugar {
  font-size: 30px  !important;
  font-family: 'nombre', sans-serif;
  color: #313030;
margin-top:-20px;
  font-weight: bold;
  margin-bottom: 5px;
}
.evento-lugarparroquia {
  font-size: 26px  !important;
  font-family: 'nombre', sans-serif;
  color: #313030;
margin-top:-20px;

  font-weight: bold;
  margin-bottom: 5px;
}

.evento-direccion {
  font-family: 'padres';
  font-size: 17px;
  line-height: 1.4;
  font-weight: 800;
  color: #080808c6;
}
.btn-mapa {
  margin-top: 10px;
  background: #000000c5;
  color: rgb(255, 255, 255);
  font-size: 14px;
  padding: 6px 16px;
  text-decoration: none;
  font-family: 'padres';
  border-radius: 18px;
  font-weight: 800;
  display: inline-block;
  transition: background 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25); /* Sombra para efecto 3D */
}

.btn-mapa:hover {
  background: #c49b9b;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35); /* Más intensa al pasar el mouse */
}


.linea-central {
  width: 2px;
  height: 60px;
  margin: 20px auto;
  background-color: #ffffff;
  transform: scaleY(0);
}

.besos-decorativos {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0; /* detrás del texto, encima del fondo */
  overflow: hidden;
  z-index: 3;
}

.beso {
    filter: brightness(0.4); /* 🔥 Oscurece ligeramente el marco */

  position: absolute;
  opacity: 0.32; /* baja opacidad para no interferir */
}

.beso1 {
  top: 60px;
  left: 15%;
  width: 50px;
  transform: rotate(-15deg);
}

.beso2 {
  top: 200px;
  right: 10%;
  width: 70px;
  transform: rotate(20deg);
}

.beso3 {
  top: 400px;
  left: 50%;
  width: 90px;
  transform: rotate(-30deg);
}

.beso4 {
  bottom: 100px;
  left: 25%;
  width: 60px;
  transform: rotate(8deg);
}

.beso5 {
  bottom: 30px;
  right: 20%;
  width: 40px;
  transform: rotate(-10deg);
}
.bolas-container {
  position: relative;
  z-index: 3;
}

.bola {
  position: absolute;
  top: -40px;
  width: 140px;
  opacity: 1;
  z-index: 1;
}

.bola-left {
  left: -50px;
  transform: rotate(-15deg);
}

.bola-right {
  right: -50px;
  top:450px;
  transform: rotate(15deg);
}

.bola-left1 {
  left: -50px;
    top:1050px;

  transform: rotate(-15deg);
}.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
      background-color: #d9d2f1 !important;
  z-index: 2;
  pointer-events: none;
}

.rasgado-superior {
  top: 0;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior {
  bottom: 0;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}
.icono-mapa {
  width: 70px; /* o el tamaño que desees */
  height: auto;
}
.flores-laterales {
  position: relative;
  z-index: 2;
  pointer-events: none;
}

.flor {
  position: absolute;
  opacity: 0;
  width: 290px;
  max-width: 40vw;
  z-index: 0;
  transition: opacity 0.3s ease;
}

.flor1 {
  top: 500px;
  left: -60px;
}

.flor2 {
  top:1150px;
  right: -70px;
  opacity: 0;
}


</style>